import script from "./assiduidade.vue?vue&type=script&setup=true&lang=js"
export * from "./assiduidade.vue?vue&type=script&setup=true&lang=js"

import "./assiduidade.vue?vue&type=style&index=0&id=a39b37ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a39b37ae"]])

export default __exports__